var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRenameIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-rename",
    transform: "translate(-1295 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 16,
    height: 16,
    transform: "translate(1295 98)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drive_file_rename_outline_FILL0_wght400_GRAD-25_opsz20",
    d: "M6.574,13.181l2.384-2.4h4.77v2.4ZM2.922,11.988h.83l5.1-5.1-.83-.83-5.1,5.1Zm8.453-5.9L8.839,3.536l.694-.695a1.118,1.118,0,0,1,.838-.362,1.167,1.167,0,0,1,.853.362l.845.861a1.1,1.1,0,0,1,.34.845,1.2,1.2,0,0,1-.355.861Zm-.83.815L4.265,13.181H1.729V10.645L8.008,4.366Zm-2.1-.422-.422-.422.83.83Z",
    transform: "translate(1295.271 98.17)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRenameIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/renameIcon.22850854.svg";
export { ForwardRef as ReactComponent };